module.exports = __webpack_public_path__ + "static/img/ic_menu.bafce666.png";